import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Trophy, Settings, LogOut, Dumbbell } from 'lucide-react';
export function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const navItems = [{
    id: '/admin/dashboard',
    icon: LayoutDashboard,
    label: 'Monitoramento'
  }, {
    id: '/admin/hall-of-fame',
    icon: Trophy,
    label: 'Hall da Fama'
  }, {
    id: '/admin/settings',
    icon: Settings,
    label: 'Configurações'
  }];
  return <div className="min-h-screen bg-gray-100 flex" data-id="element-94">
      {/* Sidebar */}
      <aside className="w-64 bg-[var(--secondary)] text-white flex-shrink-0 flex flex-col" data-id="element-95">
        <div className="p-6 flex items-center gap-3" data-id="element-96">
          <div className="bg-[var(--primary)] p-2 rounded-lg text-white" data-id="element-97">
            <Dumbbell size={24} data-id="element-98" />
          </div>
          <div data-id="element-99">
            <h1 className="font-bold text-lg leading-tight" data-id="element-100">Iron Gym</h1>
            <p className="text-xs text-gray-400" data-id="element-101">Painel Administrativo</p>
          </div>
        </div>

        <nav className="flex-1 px-4 py-6 space-y-2" data-id="element-102">
          {navItems.map(item => {
          const isActive = location.pathname === item.id;
          const Icon = item.icon;
          return <button key={item.id} onClick={() => navigate(item.id)} className={`flex items-center gap-3 w-full p-3 rounded-lg transition-all ${isActive ? 'bg-[var(--primary)] text-white shadow-md' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`} data-id="element-103">
                <Icon size={20} data-id="element-104" />
                <span className="font-medium" data-id="element-105">{item.label}</span>
              </button>;
        })}
        </nav>

        <div className="p-4 border-t border-gray-700" data-id="element-106">
          <button onClick={() => navigate('/')} className="flex items-center gap-3 w-full p-3 rounded-lg text-gray-300 hover:bg-gray-700 hover:text-white transition-colors" data-id="element-107">
            <LogOut size={20} data-id="element-108" />
            <span data-id="element-109">Sair</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto" data-id="element-110">
        <header className="bg-white shadow-sm px-8 py-4 flex justify-between items-center sticky top-0 z-10" data-id="element-111">
          <h2 className="text-xl font-semibold text-gray-800" data-id="element-112">
            {navItems.find(i => i.id === location.pathname)?.label || 'Painel'}
          </h2>
          <div className="flex items-center gap-4" data-id="element-113">
            <div className="text-right hidden sm:block" data-id="element-114">
              <p className="text-sm font-medium text-gray-900" data-id="element-115">Admin User</p>
              <p className="text-xs text-gray-500" data-id="element-116">Gerente</p>
            </div>
            <div className="h-10 w-10 bg-gray-200 rounded-full overflow-hidden border-2 border-white shadow-sm" data-id="element-117">
              <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Admin" data-id="element-118" />
            </div>
          </div>
        </header>

        <div className="p-8 max-w-7xl mx-auto" data-id="element-119">
          <Outlet data-id="element-120" />
        </div>
      </main>
    </div>;
}